import isSameDay from 'date-fns/isSameDay';

import getEndOfDayDate from './getEndOfDayDate';

export default function getRangeValue({
  date: newlySelectedDate,
  startDate,
  endDate,
  allowSameStartAndEndDate,
}: {
  date: Date;
  startDate?: Date | null;
  endDate?: Date | null;
  allowSameStartAndEndDate?: boolean;
}): [Date | null, Date | null] {
  if (startDate && endDate) {
    return [newlySelectedDate, null];
  } else if (!startDate) {
    return [newlySelectedDate, null];
  } else if (startDate > newlySelectedDate) {
    const newEndDate = getEndOfDayDate(startDate);

    return [newlySelectedDate, newEndDate];
  } else if (isSameDay(startDate, newlySelectedDate)) {
    if (allowSameStartAndEndDate) {
      const newEndDate = getEndOfDayDate(newlySelectedDate);

      return [startDate, newEndDate];
    } else {
      return [newlySelectedDate, null];
    }
  } else {
    const newEndDate = getEndOfDayDate(newlySelectedDate);
    return [startDate, newEndDate];
  }
}
